var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-staff-list"
  }, [_vm.fetching ? _c('div', {
    staticClass: "wizard-mode-layout__loading-overlay"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__loading-spinner"
  }), _c('div', {
    staticClass: "wizard-mode-layout__loading-text"
  }, [_vm._v("載入中...")])]) : _vm._e(), _vm.staffList.length == 0 && !_vm.fetching ? _c('div', [_vm._v(" 此分店無可選用員工，請回上一頁重新選擇 ")]) : _vm._e(), _vm.selectedBranch ? _c('h4', {
    staticClass: "text-center my-2"
  }, [_vm._v(_vm._s(_vm.selectedBranch.name))]) : _vm._e(), _vm.selectedServicesForDisplay ? _c('h4', {
    staticClass: "text-center my-2"
  }, [_vm._v(_vm._s(_vm.selectedServicesForDisplay))]) : _vm._e(), _c('div', {
    staticClass: "liff-staff-list__content need-bottom"
  }, _vm._l(_vm.staffList, function (staff) {
    return _c('label', {
      key: staff.id,
      staticClass: "liff-staff-list__content-item",
      class: {
        'active': _vm.chosenStaff.id === staff.id
      },
      attrs: {
        "for": staff.id
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.chosenStaff,
        expression: "chosenStaff"
      }],
      staticClass: "liff-staff-list__checkbox",
      attrs: {
        "type": "radio",
        "id": staff.id
      },
      domProps: {
        "value": staff,
        "checked": _vm._q(_vm.chosenStaff, staff)
      },
      on: {
        "change": function change($event) {
          _vm.chosenStaff = staff;
        }
      }
    }), _c('img', {
      staticClass: "liff-staff-list__content-item-img",
      attrs: {
        "src": staff.img || require('./images/staff.png'),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "liff-staff-list__content-item-info"
    }, [_c('div', {
      staticClass: "s-flex s-flex-col s-gap-2"
    }, [_c('div', [_vm._v(_vm._s(staff.name))]), _c('div', {
      staticClass: "s-text-gray s-text-sm"
    }, [_vm._v(_vm._s(staff.position))]), staff.description ? _c('div', {
      staticClass: "s-mt-3 s-mb-3 s-border-b s-border-gray-light"
    }) : _vm._e(), staff.description ? _c('div', {
      staticClass: "s-text-gray s-text-xs"
    }, [_vm._v(_vm._s(staff.description))]) : _vm._e()])]), _vm.chosenStaff.id === staff.id ? _c('BIconCheckCircleFill', {
      staticClass: "s-text-primary liff-staff-list__content-item-check",
      attrs: {
        "height": 20
      }
    }) : _vm._e()], 1);
  }), 0), _c('div', {
    staticClass: "wizard-mode-layout__footer-navigation"
  }, [_vm.staffList.length != 0 ? _c('div', {
    staticClass: "s-flex s-justify-between s-items-center s-mb-3"
  }, [_c('div', {
    staticClass: "s-font-medium"
  }, [_vm._v("已選："), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v(_vm._s(_vm.chosenStaff.name))])]), _c('div', {
    staticClass: "s-text-primary cursor-pointer s-font-medium s-flex-shrink-0",
    on: {
      "click": function click($event) {
        _vm.chosenStaff = {};
      }
    }
  }, [_vm._v("重選")])]) : _vm._e(), _c('div', {
    staticClass: "wizard-mode-layout__footer-button-wrapper"
  }, [_vm.hasPreviousStep() ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleNegativeButtonClicked
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _vm.staffList.length != 0 ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.chosenStaff.id || _vm.staffList.length == 0
    },
    on: {
      "click": _vm.handlePositiveButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForProceedButton()) + " ")]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }